<div class="profile-avatar-wrapper">
  <img class="profile-avatar-image" [src]="url" alt="">
</div>
